export const phoneRegex = /^\+(?:[0-9]{1,2}){9,14}[0-9]$/;
export const loginRegex = /^[a-zA-Z0-9._\-]*$/;
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const verificationCodeRegex = /^\d{5}$/;
export const min1UppercaseRegex = /(?=.*[A-Z])/;
export const min1NumberRegex = /(?=.*\d)/;
export const min1SpecialCharRegex = /(?=.*[!@#$%^&*])/;
export const stringCoordinatesRegex = /^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*$/;
